var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"edit-user",on:{"click":function($event){$event.stopPropagation();return _vm.editUser()}}},[_vm._v("\n  "+_vm._s(_vm.model.get('username'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }